/* Savaaya Atelier — collection / search results */
(() => {
  const root = document.querySelector('[data-plp]');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  const $ = (s, c = root) => c.querySelector(s);

  /* Grid density --------------------------------------------------------- */
  const applyDensity = () => {
    const grid = $('[data-grid]');
    if (!grid) return;
    let pref = {};
    try { pref = JSON.parse(localStorage.getItem('savaaya-density') || '{}'); } catch (e) { /* ignore */ }
    if (pref.d) grid.style.setProperty('--cols-d', pref.d);
    if (pref.m) grid.style.setProperty('--cols-m', pref.m);
    const d = getComputedStyle(grid).getPropertyValue('--cols-d').trim();
    const m = getComputedStyle(grid).getPropertyValue('--cols-m').trim();
    root.querySelectorAll('[data-density-d]').forEach((b) => b.classList.toggle('is-active', b.dataset.densityD === d));
    root.querySelectorAll('[data-density-m]').forEach((b) => b.classList.toggle('is-active', b.dataset.densityM === m));
  };
  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-density-d],[data-density-m]');
    if (!b) return;
    let pref = {};
    try { pref = JSON.parse(localStorage.getItem('savaaya-density') || '{}'); } catch (err) { /* ignore */ }
    if (b.dataset.densityD) pref.d = b.dataset.densityD;
    if (b.dataset.densityM) pref.m = b.dataset.densityM;
    try { localStorage.setItem('savaaya-density', JSON.stringify(pref)); } catch (err) { /* ignore */ }
    applyDensity();
  });
  applyDensity();

  /* Ajax rendering ------------------------------------------------------- */
  let controller;
  const render = (url, push = true) => {
    if (controller) controller.abort();
    controller = new AbortController();
    root.classList.add('is-loading');
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);
    fetch(fetchUrl.toString(), { signal: controller.signal })
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-results]', '[data-active-filters]', '[data-count]', '[data-filter-count]', '[data-count-btn]'].forEach((sel) => {
          const fresh = doc.querySelector(sel);
          const current = root.querySelector(sel);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
        const freshFacets = doc.querySelector('[data-facets]');
        const facets = root.querySelector('[data-facets]');
        if (freshFacets && facets) {
          const openState = Array.from(facets.querySelectorAll('details')).map((d) => d.open);
          facets.innerHTML = freshFacets.innerHTML;
          facets.querySelectorAll('details').forEach((d, i) => { if (openState[i] !== undefined) d.open = openState[i]; });
        }
        if (push) {
          const clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          window.history.pushState({ plp: true }, '', clean.toString());
        }
        applyDensity();
        initLoadMore();
        if (window.theme && window.theme.initReveal) window.theme.initReveal(root);
      })
      .catch(() => {})
      .finally(() => root.classList.remove('is-loading'));
  };

  const formUrl = () => {
    const form = document.getElementById('FacetForm');
    const params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach((v, k) => { if (v !== '' && k !== 'sort_by') params.append(k, v); });
    }
    const sort = root.querySelector('[data-sort]');
    if (sort) params.set('sort_by', sort.value);
    const base = form ? form.getAttribute('action') : window.location.pathname;
    return `${base}?${params.toString()}`;
  };

  const debounced = (() => { let t; return () => { clearTimeout(t); t = setTimeout(() => render(formUrl()), 400); }; })();

  document.addEventListener('change', (e) => {
    if (e.target.closest('[data-facet-form]')) {
      if (e.target.type === 'number') debounced(); else render(formUrl());
    }
    if (e.target.matches('[data-sort]')) render(formUrl());
  });
  document.addEventListener('submit', (e) => {
    if (e.target.matches('[data-facet-form]')) { e.preventDefault(); render(formUrl()); }
  });
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-filter-link], [data-clear-all]');
    if (!a) return;
    e.preventDefault();
    render(a.href);
  });
  window.addEventListener('popstate', () => render(window.location.href, false));

  /* Load more ------------------------------------------------------------ */
  let io;
  function initLoadMore() {
    const btn = root.querySelector('[data-load-more]');
    if (io) io.disconnect();
    if (!btn) return;
    const load = (e) => {
      if (e) e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      const url = new URL(btn.href, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      fetch(url.toString())
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = root.querySelector('[data-grid]');
          const freshGrid = doc.querySelector('[data-grid]');
          if (grid && freshGrid) Array.from(freshGrid.children).forEach((li) => grid.appendChild(li));
          const freshMore = doc.querySelector('[data-more]');
          const more = root.querySelector('[data-more]');
          if (more && freshMore) more.innerHTML = freshMore.innerHTML;
          if (window.theme && window.theme.initReveal) window.theme.initReveal(root);
          initLoadMore();
        })
        .catch(() => { window.location.href = btn.href; });
    };
    btn.addEventListener('click', load);
    if (btn.dataset.auto === 'true' && 'IntersectionObserver' in window) {
      io = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) load(); }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(btn);
    }
  }
  initLoadMore();
})();
